import { Component } from '@angular/core';

@Component({
  selector: 'app-map-layout',
  templateUrl: './map-layout.html',
})
export class MapLayoutComponent {}
